import axiox from "axios";
import { Urls } from "./Urls";
import { UserLocalStorage } from "@/service/user.localstorge";
export interface ResponseData {
  code: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  message: string;
}

export class Http {
  static post<T>(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any,
    contentType = "application/json"
  ): Promise<T> {
    this.setHeaderInfo(contentType);
    const postUrl = Urls.base_url + url;
    return new Promise((resolve, reject) => {
      axiox.post<ResponseData>(postUrl, data).then(
        axioxRes => {
          const res: ResponseData = axioxRes.data;
          if (res.code === 0) {
            resolve(res.data);
          } else {
            reject(res);
          }
        },
        res => {
          reject(res);
        }
      );
    });
  }

  static postUser<T>(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any,
    contentType = "application/json"
  ): Promise<T> {
    this.setHeaderInfo(contentType);
    const postUrl = Urls.user_baseUrl + url;
    return new Promise((resolve, reject) => {
      axiox.post<ResponseData>(postUrl, data).then(
        axioxRes => {
          const res: ResponseData = axioxRes.data;
          if (res.code === 0) {
            resolve(res.data);
          } else {
            reject(res);
          }
        },
        res => {
          reject(res);
        }
      );
    });
  }

  static get<T>(url: string): Promise<T> {
    this.setHeaderInfo();
    const getUrl = Urls.base_url + url;
    return new Promise((resolve, reject) => {
      axiox.get<ResponseData>(getUrl).then(
        axioxRes => {
          const res: ResponseData = axioxRes.data;
          if (res.code === 0) {
            resolve(res.data);
          } else {
            reject(res);
          }
        },
        res => {
          reject(res);
        }
      );
    });
  }

  static setHeaderInfo(contentType = "application/json") {
    axiox.defaults.headers.common.Authorization =
      "token " + UserLocalStorage.getAccessToken();
    axiox.defaults.headers.post["Content-Type"] = contentType;
  }
}
